<template>
	<div>
		<MultipleSelectSettingsEditor @onChange="onChange" addOptionText="Add item" keyPlaceholder="Enter item..." :options="manualOptions" />
	</div>
</template>

<script>
import InputComponentMixinBase from './mixins/InputComponentMixinBase';
import MultipleSelectSettingsEditor from '@/components/BlockEditorWidget/FieldSettings/FieldOptions/MultipleSelectSettingsEditor/MultipleSelectSettingsEditor';
export default {
	name: 'MultiSelectManualOptions',
	mixins: [InputComponentMixinBase],
	components: { MultipleSelectSettingsEditor },
	props: { options: { type: Array } },
	computed: {
		getDefaultOptionsArray() {
			return [{ text: '', value: '', id: 1 }];
		},
		manualOptions() {
			return this.options?.length ? this.options : this.getDefaultOptionsArray;
		},
	},
	methods: {
		onChange(result) {
			const formattedResult = result.map((item) => ({ ...item, value: item.text, option: item.text }));
			this.$emit('update-params-map', { value: formattedResult });
		},
	},
	mounted() {
		this.$emit('close');
	},
};
</script>
<style lang="scss" scoped></style>
